  <template>
  <div class="home-box">
    <PageTitle :title="pageTitle" class="py-5"></PageTitle>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular color="#FFB300" indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <ExpenseTypeCreateForm :formData="formData" :mode="mode" :id="id" :proploading="loading"></ExpenseTypeCreateForm>
      </div>
    </v-row>
  </div>
  </template>
    
  <script>
  import ExpenseTypeCreateForm from "@/components/expenses/ExpenseTypeCreateForm";
  import PageTitle from "@/components/shared/PageTitle";
  import { createNamespacedHelpers } from "vuex";

  const { mapGetters } = createNamespacedHelpers("auth");
  import { ExpenseService } from "@/services/expense-service.js";

  export default {
    name: "CreateEditExpenseType",
    components: {
      PageTitle,
      ExpenseTypeCreateForm,
    },
    props: {
      mode: { type: String, required: true }, 
      id: { type: String, default: null }, 
    },
    data() {
      return {
        loading: false,
        formData: {
          name: "",
          description: "",
          gl_account_id: "",
        },
      };
    },
    computed: {
      ...mapGetters({
        vuexloading: "loading",
        profile: "profile",
        hasPermission: "hasPermission",
      }),
      pageTitle() {
        return this.mode === "edit" ? "Update Expense Type" : "Create Expense Type";
      },
    },
    mounted() {
      if (this.mode === "edit") {
        this.fetchExpenseType();
      }
    },
    methods: {
      async fetchExpenseType() {
        if (!this.id) return;
        try {
          this.loading = true;
          const expenseType = await ExpenseService.getExpenseTypeDetails(this.id);
          console.log("Edit fetched ",expenseType);
          this.formData = {
            name: expenseType.name,
            description: expenseType.description,
            gl_account_id: expenseType.gl_account_id,
          };
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>